var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevMicrositesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dev-microsites-icon_svg__a",
    d: "M0 0h43.506v43.506H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dev-microsites-icon_svg__c",
    d: "M0 60h69.83V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dev-microsites-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dev-microsites-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.506 21.753c0 12.013-9.738 21.753-21.753 21.753C9.74 43.506 0 33.766 0 21.753 0 9.739 9.739 0 21.753 0c12.015 0 21.753 9.739 21.753 21.753",
    fill: "#F8D7CC",
    mask: "url(#dev-microsites-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.193 15.272H8.737a2.183 2.183 0 00-2.182 2.182v36.001h57.82v-36a2.183 2.183 0 00-2.182-2.183",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.465 53.454h-2.181v-36c0-.601-.49-1.091-1.091-1.091H8.737c-.601 0-1.09.49-1.09 1.09v36.001H5.463v-36a3.277 3.277 0 013.273-3.273h53.456a3.277 3.277 0 013.272 3.273v36z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.738 53.454H42.557l-1.092 1.091H28.374l-1.091-1.09H1.1v2.181c0 1.8 1.472 3.273 3.272 3.273h61.092a3.273 3.273 0 003.273-3.273v-2.182z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.465 60H4.373A4.368 4.368 0 01.01 55.636v-3.273h27.725l1.09 1.091h12.188l1.092-1.09H69.83v3.272A4.368 4.368 0 0165.465 60zM2.192 54.545v1.091c0 1.204.978 2.182 2.181 2.182h61.092a2.184 2.184 0 002.182-2.182v-1.09H43.01l-1.092 1.09H27.922l-1.09-1.09H2.191z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    d: "M26.314 24.846l-8.074 7.07v12.316h16.155V31.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M38.177 37.376L26.313 26.993 14.457 37.374l-2.128-2.43 13.984-12.246 13.993 12.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M36.01 45.848H16.625V31.915h3.23v10.701h12.924V31.92h3.231z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dev-microsites-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dev-microsites-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#dev-microsites-icon_svg__d)",
    d: "M24.702 44.232h3.231v-4.847h-3.231zM16.624 31.915h3.23v-5.453h-3.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#dev-microsites-icon_svg__d)",
    d: "M49.571 32.659l-5.652 4.948v8.623h11.31v-8.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#dev-microsites-icon_svg__d)",
    d: "M57.876 41.43l-8.305-7.269-8.3 7.267-1.489-1.7 9.789-8.573 9.795 8.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#dev-microsites-icon_svg__d)",
    d: "M56.36 47.36H42.787v-9.753h2.263v7.491h9.047V37.61h2.261z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#dev-microsites-icon_svg__d)",
    d: "M48.444 46.23h2.261v-3.394h-2.261zM42.788 37.607h2.262v-3.819h-2.262z"
  }))));
}
export default SvgDevMicrositesIcon;